
import React from "react";
import { PhoneCall, CalendarDays, Clock } from "lucide-react";

export const AssistanceFooter: React.FC = () => {
  return (
    <div className="mt-8 p-4 bg-gray-50 rounded-lg border border-gray-100 shadow-sm">
      <div className="text-center">
        <h3 className="text-lg font-semibold mb-1">Need Assistance?</h3>
        <p className="text-gray-600 mb-3">For questions or help regarding permits, please contact:</p>
        
        <div className="font-medium">Fish &amp; Game Department:</div>
        <div className="flex items-center justify-center mt-1">
          <PhoneCall className="h-4 w-4 mr-2 text-tribal-primary" />
          <span>208-759-3246</span>
        </div>
        <div className="flex items-center justify-center mt-1">
          <CalendarDays className="h-4 w-4 mr-2 text-tribal-primary" />
          <span>Monday – Friday</span>
        </div>
        <div className="flex items-center justify-center mt-1">
          <Clock className="h-4 w-4 mr-2 text-tribal-primary" />
          <span>8:00 am – 5:00 pm (Mountain Standard Time)</span>
        </div>
      </div>
    </div>
  );
};
